// extracted by mini-css-extract-plugin
export default {"root":"FilterPopup_root__fYOf9","popup":"FilterPopup_popup__EVxRY","popupSize":"FilterPopup_popupSize__xoKmf","isOpen":"FilterPopup_isOpen__nmXBL"};